import _classCallCheck from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

var SupressEmptyDataError = /*#__PURE__*/function () {
  function SupressEmptyDataError() {
    _classCallCheck(this, SupressEmptyDataError);
  }

  _createClass(SupressEmptyDataError, [{
    key: "activate",
    value: function activate(dygraph) {
      var originalParseArray = dygraph.parseArray_;

      dygraph.parseArray_ = function (data) {
        if (data.length === 0) {
          return null;
        }

        return originalParseArray.call(dygraph, data);
      };

      return {};
    }
  }]);

  return SupressEmptyDataError;
}();

export { SupressEmptyDataError as default };

SupressEmptyDataError.toString = function () {
  return 'SupressEmptyDataError Plugin';
};